var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVidfeo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 521,
    viewBox: "0 0 520 521",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M518.844 1H1.40723V414.729H518.844V1Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M518.844 414.729H1.40723V520H518.844V414.729Z",
    fill: "#1D1D1B",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M462.894 193.112C456.66 199.17 443.763 214.027 443.705 235.925C443.659 252.332 450.252 264.818 456.035 272.646C458.823 276.415 456.151 281.733 451.467 281.733H307.935C303.124 281.733 300.486 276.161 303.528 272.426C309.613 264.969 316.402 253.233 316.9 237.613C317.605 215.102 304.766 199.725 297.988 193.204C296.068 191.354 296.079 188.302 298 186.464C304.581 180.174 316.772 165.618 316.61 144.02C316.495 127.984 309.624 115.925 303.471 108.34C300.452 104.606 303.1 99.0562 307.901 99.0562H451.027C455.769 99.0562 458.43 104.49 455.526 108.248C449.836 115.624 443.462 127.151 442.861 142.344C441.936 165.606 456.244 181.562 462.848 187.747C464.398 189.192 464.421 191.632 462.894 193.112Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M359.084 220.294C360.733 220.294 362.069 218.959 362.069 217.311C362.069 215.663 360.733 214.328 359.084 214.328C357.436 214.328 356.1 215.663 356.1 217.311C356.1 218.959 357.436 220.294 359.084 220.294Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M386.995 220.294C388.644 220.294 389.98 218.959 389.98 217.311C389.98 215.663 388.644 214.328 386.995 214.328C385.347 214.328 384.011 215.663 384.011 217.311C384.011 218.959 385.347 220.294 386.995 220.294Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M358.204 229.219H388.937C388.856 229.844 388.613 231.069 387.711 232.295C386.485 233.971 384.819 234.561 384.241 234.734C377.613 234.734 370.985 234.734 364.358 234.734C363.802 234.688 361.755 234.468 360.055 232.769C358.69 231.405 358.32 229.832 358.204 229.219Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M296.555 364.516C295.063 370.956 294.08 375.292 294.08 375.292",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M366.498 414.012C372.941 406.74 387.11 389.744 401.881 365.36C423.464 329.773 430.473 307.482 430.473 307.482",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M308.179 413.192C307.902 409.943 308.434 405.792 309.88 401.641C312.332 394.612 319.214 383.408 322.163 372.228C325.113 361.048 324.812 357.568 319.225 352.238C313.939 347.185 309.903 337.6 314.414 328.177C319.7 317.147 330.029 308.823 330.029 308.823",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M363.874 306.002H363.861",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M374.525 309.932V309.921",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M385.387 311.933L385.353 312.466",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M385.722 304.221L385.699 304.754",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M395.311 312.153L395.253 311.864",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M394.074 304.673L394.005 304.221",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M455.353 365.557C454.335 368.655 452.878 371.916 451.131 375.246C449.35 378.633 447.28 382.079 445.047 385.466V385.478C444.029 387.027 442.965 388.576 441.901 390.103C440.64 391.895 439.356 393.664 438.073 395.363C437.413 396.242 436.766 397.097 436.118 397.93C435.366 398.913 434.614 399.872 433.874 400.797C433.538 401.213 433.215 401.618 432.891 402.023C431.618 403.607 430.381 405.11 429.201 406.509V406.52C426.61 409.607 424.354 412.174 422.712 414.012H285.797C277.191 404.555 274.23 398.982 256.938 394.947C237.841 390.484 228.01 379.408 228.01 379.408L247.985 349.775L265.59 323.645L296.554 364.505C300.001 349.601 306.097 323.483 308.653 314.245C312.262 301.227 323.389 290.093 330.641 289.746C333.637 289.607 339.073 289.526 344.417 289.491C345.458 291.7 347.02 293.839 348.997 295.873C350.675 297.608 352.664 299.284 354.873 300.834C357.58 302.741 360.634 304.476 363.872 305.979C367.261 307.563 370.858 308.892 374.525 309.898C378.134 310.904 381.801 311.598 385.386 311.91C386.508 312.025 387.619 312.083 388.717 312.106C389.076 312.118 389.446 312.118 389.805 312.118C391.632 312.118 393.46 312.014 395.264 311.84C399.116 311.436 402.887 310.638 406.449 309.505C409.04 308.684 411.539 307.678 413.875 306.533C416.697 305.158 419.3 303.562 421.602 301.805C423.394 300.429 425.014 298.972 426.413 297.434C428.299 295.353 429.779 293.156 430.774 290.867C445.984 294.937 452.485 304.626 455.353 310.811C459.644 320.072 464.028 339.265 455.353 365.557Z",
    fill: "#FC7157",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M467.868 414.013H422.724C428.773 407.272 443.046 390.658 451.131 375.246C450.125 388.889 463.334 400.011 466.168 405.295C467.579 407.885 467.88 411.353 467.868 414.013Z",
    fill: "#FC7157",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M408.496 289.237V281.733H356.365V289.445C354.78 289.445 352.71 289.457 350.396 289.457C350.836 290.474 351.715 291.596 352.976 292.729C354.445 294.07 356.4 295.434 358.736 296.752C361.269 298.186 364.23 299.55 367.492 300.741V300.753C370.442 301.839 373.634 302.776 376.93 303.493C379.799 304.105 382.749 304.545 385.71 304.753C388.52 304.973 391.331 304.961 394.084 304.684C397.08 304.395 399.995 303.793 402.747 302.822C404.98 302.036 407.12 301.007 409.097 299.689C410.59 298.695 412.012 297.538 413.319 296.197C414.545 294.937 415.702 293.515 416.72 291.919C417.298 291.029 417.83 290.081 418.328 289.075C415.297 288.913 412.024 288.971 408.496 289.237Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M430.774 290.902C429.78 293.191 428.299 295.388 426.414 297.469L416.732 291.908C417.311 291.018 417.843 290.069 418.34 289.064C423.013 289.272 427.142 289.919 430.774 290.902Z",
    fill: "#FC7157",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M426.414 297.469C425.014 299.007 423.406 300.475 421.602 301.839L413.32 296.186C414.546 294.925 415.703 293.503 416.721 291.908L426.414 297.469Z",
    fill: "#FC7157",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M421.601 301.839C419.299 303.597 416.697 305.181 413.875 306.568L409.098 299.677C410.59 298.683 412.012 297.527 413.319 296.186L421.601 301.839Z",
    fill: "#FC7157",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M413.875 306.568C411.539 307.713 409.04 308.719 406.449 309.54L402.748 302.822C404.98 302.036 407.12 300.995 409.098 299.689L413.875 306.568Z",
    fill: "#FC7157",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M395.253 311.863C393.449 312.048 391.621 312.141 389.794 312.141C388.348 312.141 386.879 312.072 385.375 311.921L385.687 304.741C388.498 304.961 391.309 304.949 394.062 304.672L395.253 311.863Z",
    fill: "#FC7157",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M385.699 304.753L385.387 311.933C381.812 311.621 378.146 310.927 374.525 309.921L376.92 303.493C379.788 304.106 382.738 304.557 385.699 304.753Z",
    fill: "#FC7157",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M406.45 309.528C402.876 310.673 399.116 311.471 395.265 311.864L394.085 304.672C397.081 304.383 399.996 303.782 402.748 302.811L406.45 309.528Z",
    fill: "#FC7157",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M376.919 303.493L374.525 309.921C370.858 308.915 367.25 307.586 363.872 306.002L367.481 300.764C370.43 301.839 373.623 302.787 376.919 303.493Z",
    fill: "#FC7157",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M367.482 300.752L363.873 306.002C360.623 304.499 357.581 302.753 354.874 300.857L358.737 296.764C361.259 298.186 364.231 299.562 367.482 300.752Z",
    fill: "#FC7157",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M358.725 296.764L354.862 300.857C352.653 299.307 350.675 297.631 348.986 295.897L352.965 292.74C354.434 294.07 356.389 295.434 358.725 296.764Z",
    fill: "#FC7157",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M352.976 292.74L348.997 295.897C347.031 293.862 345.458 291.711 344.417 289.515C346.476 289.503 348.512 289.491 350.385 289.48C350.837 290.486 351.716 291.607 352.976 292.74Z",
    fill: "#FC7157",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M231.019 286.323C231.03 286.335 231.03 286.335 231.03 286.335C231.817 287.491 232.303 288.208 232.303 288.208",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M231.03 286.335C231.019 286.323 231.019 286.323 231.019 286.323",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M232.441 305.239C231.99 304.522 231.77 303.504 231.862 302.117C232.198 297.55 237.9 293.041 244.216 293.087C254.417 307.701 265.591 323.657 265.591 323.657L247.986 349.786L245.754 346.121L235.332 328.952C235.332 328.952 226.31 329.206 222.725 323.529C222.794 323.529 222.863 323.518 222.933 323.518C225.836 323.148 224.98 319.853 223.685 317.078C224.668 317.309 225.686 317.378 226.727 317.24C228.994 316.951 229.19 315.031 228.612 312.858C229.086 312.927 229.572 312.973 230.069 312.973C233.863 312.973 232.984 308.256 231.723 304.58C231.99 304.822 232.232 305.042 232.441 305.239Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M232.44 305.239C233.574 306.626 236.998 306.672 238.86 304.869C242.735 301.123 245.21 301.77 245.21 301.77",
    fill: "#98282A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M232.44 305.239C233.574 306.626 236.998 306.672 238.86 304.869C242.735 301.123 245.21 301.77 245.21 301.77",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M230.08 312.962C229.583 312.962 229.097 312.916 228.623 312.846C221.961 311.794 217.507 303.736 215.992 300.117C215.726 299.481 215.518 298.856 215.379 298.232C214.326 293.654 216.478 289.48 222.377 291.168C222.527 291.688 222.736 292.243 223.002 292.81C225.303 297.816 229.201 302.105 231.734 304.568C232.995 308.256 233.874 312.962 230.08 312.962Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M231.874 302.117C231.77 303.504 232.001 304.533 232.452 305.239C232.233 305.042 231.99 304.811 231.747 304.568C229.214 302.105 225.316 297.816 223.014 292.81C222.748 292.231 222.54 291.688 222.389 291.168C220.307 284.219 227.386 282.045 231.03 286.323C229.121 283.525 225.431 278.126 222.563 273.998C218.491 268.171 224.922 264.83 228.034 269.663C229.387 271.744 236.524 282.034 244.239 293.087C237.912 293.041 232.198 297.55 231.874 302.117Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M226.75 317.228C225.698 317.355 224.691 317.298 223.708 317.066C218.341 315.864 214.108 310.037 212.465 307.216C212.315 306.961 212.188 306.695 212.06 306.429C210.233 302.626 211.031 298.486 215.392 298.232C215.53 298.856 215.739 299.492 216.005 300.117C217.52 303.735 221.973 311.794 228.635 312.846C229.202 315.031 229.017 316.939 226.75 317.228Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M222.944 323.506C222.874 323.518 222.805 323.518 222.735 323.518C216.709 324.131 211.77 317.425 210.047 314.453C208.057 311.031 208.428 307.031 212.048 306.418C212.175 306.684 212.302 306.938 212.453 307.204C214.095 310.025 218.329 315.852 223.696 317.055C224.991 319.841 225.847 323.136 222.944 323.506Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7855 445.9H32.6133V490.009H74.7855V445.9Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M152.573 490.009V445.9L113.998 467.949L152.573 490.009Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M192.883 490.009V445.9L154.319 467.949L192.883 490.009Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M367.122 490.829V446.721L405.685 468.769L367.122 490.829Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M326.802 490.829V446.721L365.377 468.769L326.802 490.829Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M236.905 490.009V445.9L292.738 467.949L236.905 490.009Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M463.116 444.802H437.588V482.69H463.116V444.802Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M489.684 444.802H463.115V482.69H489.684V444.802Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M457.031 453.438C451.421 447.831 443.498 454.306 443.498 462.04C443.498 468.781 446.505 474.423 451.525 474.793C457.713 475.256 457.714 468.769 457.714 468.769",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M484.549 453.716C476.892 444.802 468.217 453.566 468.217 461.798C468.217 468.966 470.322 475.406 476.244 475.406C482.282 475.406 483.126 468.365 483.126 468.365",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M256.719 71.5967H27.9297V261.581H256.719V71.5967Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M150.352 120.018C150.352 120.018 150.26 120.157 150.086 120.388",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M137.93 129.209C139.121 128.92 140.197 128.863 141.053 128.932",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M129.843 136.887C132.434 135.245 135.951 134.748 137.408 135.048",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M126.097 145.107C127.855 144.506 130.226 143.939 132.621 144.147",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M256.719 239.937V261.593H219.521C209.412 249.638 157.801 188.51 152.561 181.908C152.156 181.388 151.694 180.822 151.208 180.197C151 179.943 150.791 179.665 150.572 179.388C144.279 171.376 132.678 156.507 125.819 151.05C124.766 150.206 124.35 148.784 124.859 147.523C125.171 146.76 125.611 145.939 126.097 145.107C127.033 143.477 128.167 141.719 128.896 139.95C129.231 139.141 129.578 138.066 129.833 136.887C129.983 136.216 130.11 135.511 130.191 134.794C132.481 131.372 135.431 129.799 137.918 129.209C139.502 124.585 143.979 120.018 150.074 120.388C149.114 121.706 145.76 126.354 143.285 129.984C140.555 133.984 143.851 140.043 151 135.534C148.744 144.182 155.997 144.379 157.593 143.246C159.189 144.182 163.226 145.396 162.763 147.466C162.289 149.535 162.775 154.345 168.408 153.027C173.011 151.952 179.685 143.061 179.685 143.061C179.685 143.061 182.762 137.326 177.152 132.32C177.025 132.204 176.898 132.1 176.782 131.973C175.903 131.129 175.301 130.319 174.954 129.556C173.277 125.972 176.932 123.556 180.749 124.226C185.48 125.047 194.294 132.146 191.61 141.916C188.938 151.697 179.893 159.825 179.893 159.825L256.719 239.937Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M161.663 124.434C156.076 132.007 151.01 135.522 151.01 135.522C143.862 140.043 140.565 133.973 143.295 129.973C145.77 126.342 149.125 121.694 150.085 120.376C154.11 117.335 161.027 117.243 161.663 124.434Z",
    fill: "#FDC82E",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M170.247 129.707C166.256 140.356 157.604 143.235 157.604 143.235C156.008 144.368 148.756 144.171 151.011 135.523C151.011 135.523 156.089 131.996 161.664 124.435C167.031 121.533 170.744 125.256 170.247 129.707Z",
    fill: "#FDC82E",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M176.782 131.95C174.781 140.343 165.458 145.766 162.798 147.153C162.844 145.269 159.12 144.124 157.593 143.234C157.593 143.234 166.256 140.355 170.235 129.707C171.403 129.348 173.485 129.429 174.943 129.533C175.301 130.296 175.903 131.117 176.782 131.95Z",
    fill: "#FDC82E",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M179.683 143.049C179.683 143.049 173.021 151.94 168.406 153.015C162.761 154.333 162.287 149.524 162.761 147.454C162.784 147.35 162.796 147.257 162.796 147.165C165.456 145.766 174.779 140.343 176.78 131.961C176.896 132.088 177.023 132.192 177.15 132.308C182.76 137.314 179.683 143.049 179.683 143.049Z",
    fill: "#FDC82E",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M150.571 179.388C150.56 182.648 150.086 186.244 150.086 186.244L86.3994 261.581H27.9297V248.805L115.409 160.97C115.409 160.97 107.254 153.339 107.601 148.587C107.937 143.835 118.3 128.539 125.229 127.568C129.832 126.92 130.642 130.909 130.191 134.782C130.11 135.499 129.983 136.204 129.832 136.875C129.578 138.043 129.231 139.118 128.895 139.939C128.167 141.708 127.033 143.465 126.096 145.095C125.61 145.939 125.159 146.749 124.859 147.512C124.35 148.772 124.755 150.194 125.819 151.038C132.678 156.507 144.291 171.387 150.571 179.388Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M342.034 353.047C342.717 355.383 344.244 357.395 344.984 359.719",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M335.153 351.833C335.281 352.284 335.616 352.642 335.928 352.989C337.559 354.839 338.844 357.002 339.676 359.326",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M328.2 350.203C328.987 351.417 329.935 352.515 331.011 353.475C331.821 354.192 332.7 354.84 333.464 355.591C334.227 356.343 334.91 357.245 335.199 358.285",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M327.159 354.643C329.623 356.967 331.612 359.776 333 362.863",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M373.196 323.09C372.756 323.576 372.328 324.073 371.889 324.559C371.611 324.871 371.333 325.195 371.102 325.542C370.882 325.888 370.72 326.27 370.535 326.652C369.934 327.9 369.147 329.068 368.21 330.097",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M376.505 324.524C375.811 325.275 375.186 326.096 374.654 326.975C374.307 327.553 373.983 328.155 373.671 328.756C373.162 329.727 372.653 330.699 372.144 331.681",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M378.772 327.299C377.222 329.635 375.926 332.144 374.908 334.746",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M381.339 329.761C381.085 329.993 380.958 330.328 380.83 330.64C379.986 332.756 379.037 334.826 377.996 336.861",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M388.684 312.072C389.551 313.448 390.43 314.812 391.298 316.188C391.587 316.651 391.888 317.113 392.304 317.449",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M384.53 314.107C384.843 314.188 385.132 314.373 385.386 314.569C386.879 315.726 387.769 317.472 388.614 319.16",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M382.726 316.13C383.639 318.189 384.553 320.258 385.479 322.317",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M436.835 310.464L453.051 308.21",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M436.835 315.795L455.631 314.708",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M436.835 321.125L456.232 319.645",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M442.168 324.605C442.388 324.535 458.234 324.605 458.234 324.605",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M447.198 328.894H458.973",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M435.875 330.085L441.358 345.624",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M429.954 328.154L436.466 344.445",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M425.732 328.894L433.205 346.665",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M423.511 334.745L429.953 350.284",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M420.77 339.115L427.513 355.695",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M388.197 353.845L379.036 367.545",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M386.185 347.948L377.059 362.921",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M383.061 345.011L373.322 361.649",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M377.047 346.746L368.465 361.221",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M371.911 347.174L362.681 362.505",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M415.54 365.708V380.345",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M420.77 364.008V377.824",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M425.73 360.747V377.327",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M431.479 362.505L429.952 376.437",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M435.874 362.505L434.243 375.246",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M439.853 362.135L438.615 373.512",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M401.719 384.241L420.769 385.131",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M397.497 390.82L421.567 390.092",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M402.378 395.051C408.231 396.762 422.134 398.624 422.134 398.624",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M403.349 398.624L421.15 402.694",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M417.496 404.393L420.77 408.14",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M445.301 379.847L443.254 383.675",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M441.358 380.344L440.617 388.103",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M437.992 381.882L437.425 393.363",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M434.243 382.657L433.353 397.849",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M431.479 384.241L428.98 403.561",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M427.512 384.241L425.73 407.099",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M456.59 347.405L451.131 355.695",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M453.086 346.746L447.198 352.55",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M448.414 345.011L443.231 351.753",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M443.231 346.283L439.229 351.753",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M456.592 333.669L453.862 341.208",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M453.087 335.207L450.681 341.208",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M448.866 336.849L445.303 341.752",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M444.053 336.294L441.913 341.208",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M461.773 410.036L461.368 410.996",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M461.449 406.012L458.244 410.996",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M457.54 405.295L453.977 410.036",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M376.019 383.57L381.132 390.462",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M373.322 385.131L379.036 394.623",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M371.911 387.016L375.37 395.664",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M369.275 388.623L373.324 397.272",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M366.499 390.82L370.039 396.845",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M362.682 391.721L368.268 402.058",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M351.322 378.9L354.365 387.017",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M354.365 377.327L359.478 383.571",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M356.921 374.332L362.682 378.9",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M339.027 384.692L345.887 387.016",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M342.462 389.883L351.322 390.461",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M334.135 389.884L348.709 395.052",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M332.723 394.623L345.886 399.884",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M331.092 398.624L340.993 400.659",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M322.487 375.835C323.343 375.87 324.084 376.402 324.801 376.887C327.704 378.841 331.012 380.171 334.459 380.784",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M321.285 379.802C321.991 379.998 322.615 380.414 323.24 380.784C325.923 382.391 328.908 383.478 331.984 383.987",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M319.989 383.213C320.961 383.375 321.863 383.826 322.742 384.276C325.53 385.675 328.352 386.982 331.221 388.196",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M318.52 386.542C321.966 388.507 325.633 390.103 329.415 391.305",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M317.733 390.473C321.169 391.49 324.639 392.415 328.12 393.271",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M321.053 395.155C323.204 395.456 325.344 395.756 327.496 396.057",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M339.396 367.928C341.779 370.471 343.838 373.327 345.492 376.391",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M344.591 365.812C346.048 368.298 347.321 370.899 348.385 373.571",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M346.972 362.712C348.66 365.661 350.268 368.655 351.795 371.684",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M352.178 361.452C352.918 365.025 353.496 368.621 353.936 372.24",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M356.226 362.03C357.024 365.256 357.718 368.493 358.319 371.765",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M360.644 360.932C360.644 363.718 360.644 366.516 360.644 369.303",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M367.77 338.433C368.487 340.445 368.533 342.619 369.077 344.688",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M362.495 339.254C362.449 342.167 362.402 345.092 362.9 347.96",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M357.868 338.837C357.706 341.681 358.041 344.549 358.863 347.266",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M353.461 339.311C353.438 342.583 353.415 345.89 354.121 349.093",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M349.332 339.416C349.147 342.849 349.205 346.306 349.494 349.729",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M345.469 340.41C345.434 342.676 345.446 344.943 345.503 347.209",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M342.289 339.207C341.723 341.763 341.387 344.376 341.271 347.001",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M339.177 339.624C338.506 340.768 338.136 342.064 337.766 343.347C337.477 344.376 337.176 345.417 336.887 346.446",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M350.792 332.097C351.116 331.993 351.486 332.039 351.775 332.236C352.099 332.455 352.296 332.825 352.493 333.161C352.874 333.785 353.337 334.352 353.8 334.918",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M347.935 332.709C348.606 333.6 349.253 334.513 349.855 335.462C350.04 335.751 350.225 336.051 350.26 336.387",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M343.782 334.005C344.407 334.583 345.043 335.161 345.668 335.739C345.888 335.936 346.096 336.132 346.281 336.363C346.478 336.606 346.628 336.895 346.732 337.196",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M339.201 334.178C339.352 334.294 339.514 334.421 339.664 334.536C340.601 335.265 341.584 336.04 342.082 337.127",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M332.747 333.577C332.921 333.565 333.071 333.692 333.198 333.82C334.205 334.791 335.095 335.866 335.87 337.034",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M325.727 333.057C326.502 333.901 327.219 334.814 327.867 335.762C328.191 336.237 328.503 336.734 328.977 337.046C329.116 337.138 329.266 337.208 329.371 337.335C329.556 337.543 329.602 337.879 329.845 338.017",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M321.933 333.057C322.812 334.837 323.541 336.687 324.119 338.584",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M317.93 332.34C318.23 333.462 318.485 334.606 318.67 335.751",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M349.114 318.569C349.195 320.697 349.6 322.825 350.306 324.837",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M345.517 319.841C345.228 322.443 346.119 325.045 346.003 327.658",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M340.983 320.246C340.833 323.16 341.006 326.096 341.515 328.975",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M336.947 320.362C336.9 322.674 336.889 324.987 336.924 327.311",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M332.285 320.362C332.262 322.929 332.274 325.496 332.297 328.063",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M329.14 320.709C328.874 323.079 328.55 325.45 328.168 327.809",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M324.999 319.483C324.548 322.131 324.12 324.779 323.703 327.427",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M321.654 320.928C321.423 323.183 321.076 325.426 320.613 327.647",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M369.25 320.165C369.377 319.055 369.504 317.945 369.62 316.824C369.69 316.199 369.759 315.563 369.898 314.951C370.037 314.349 370.233 313.76 370.441 313.182C370.869 311.979 371.309 310.788 371.783 309.609",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M364.241 319.356C364.033 317.702 364.276 315.991 364.935 314.453C365.491 313.159 366.335 312.002 366.89 310.707",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M364.601 307.562C363.826 310.083 363.051 312.615 362.333 315.159C361.952 316.535 361.582 317.945 361.663 319.367",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M361.351 306.696C360.402 308.326 359.454 309.956 358.505 311.586C357.731 312.916 356.956 314.257 356.47 315.725",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M358.412 305.354C357.359 308.846 355.578 312.095 354.606 315.61",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M355.046 305.505C354.757 306.499 354.653 307.54 354.503 308.569C354.121 311.216 353.496 313.818 352.629 316.35",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M352.698 305.748C352.537 305.945 352.444 306.187 352.375 306.419C351.692 308.5 351.403 310.72 350.466 312.698",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M337.258 299.55C337.663 300.579 338.137 301.585 338.669 302.557C338.866 302.915 339.074 303.262 339.271 303.62C339.722 304.395 340.161 305.158 340.613 305.933",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M333.915 301.273C334.077 301.227 334.193 301.412 334.262 301.574C335.072 303.736 335.396 306.083 336.529 308.084",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M330.792 302.788C331.127 303.158 331.278 303.655 331.405 304.129C332.087 306.522 332.77 308.904 333.452 311.297",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M328.341 304.407C329.405 307.02 330.203 309.749 330.724 312.524",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M325.425 305.852C326.13 308.558 326.848 311.264 327.6 313.958",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M315.061 311.332C315.523 312.037 315.824 312.858 316.298 313.552C316.969 314.523 317.976 315.275 318.473 316.35",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M310.317 312.083C312.249 314.165 314.031 316.373 315.673 318.686",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M308.918 315.98C309.323 316.165 309.681 316.454 310.029 316.743C310.665 317.287 311.266 317.877 311.833 318.501C311.926 318.605 312.018 318.721 312.007 318.848",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M302.27 343.589C302.536 344.121 302.825 344.653 303.125 345.173C303.669 346.144 304.213 347.104 304.756 348.075C305.369 349.162 305.982 350.26 306.827 351.174C307.845 352.295 309.163 353.105 310.193 354.226",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M301.333 348.538C302.976 350.331 304.514 352.215 305.937 354.193",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M300.141 353.012C301.957 354.608 303.6 356.389 305.022 358.331",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M309.832 364.459C311.37 365.892 312.92 367.326 314.678 368.471C316.448 369.604 318.461 370.436 320.554 370.517",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M306.524 366.239C306.918 367.199 307.866 367.8 308.745 368.344C310.006 369.107 311.29 369.881 312.689 370.355C313.476 370.621 314.286 370.783 315.084 371.003C316.587 371.419 318.045 372.02 319.41 372.795",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M306.999 370.633C309.301 371.084 311.522 371.87 313.604 372.957C314.379 373.362 315.142 373.813 315.94 374.171C316.97 374.645 318.057 374.969 319.144 375.293",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M306.64 374.309C311.035 374.644 315.349 375.893 319.236 377.963",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M310.284 379.212C311.372 379.246 312.366 379.801 313.361 380.252C314.877 380.923 316.473 381.374 318.07 381.813",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M309.231 382.114C311.915 382.819 314.599 383.513 317.271 384.218",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M282.56 395.583C285.486 395.618 288.412 395.664 291.327 395.699C292.97 395.722 294.624 395.745 296.255 395.884C297.342 395.976 298.418 396.126 299.493 396.219C301.194 396.358 302.894 396.346 304.606 396.346",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M282.674 399.526C287.139 398.89 291.673 399.757 296.172 399.792C298.856 399.815 301.562 399.549 304.188 400.093",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M281.668 402.845C288.122 402.717 294.576 402.787 301.031 403.03C301.586 403.053 302.141 403.076 302.662 403.238C303.251 403.423 303.784 403.793 304.177 404.278",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M285.012 407.457C290.876 407.226 296.902 407.006 302.454 408.902",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M278.094 390.345C278.892 385.351 279.69 380.356 280.488 375.361",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M274.289 390.946C273.873 385.882 274.127 380.76 275.041 375.766",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M270.067 391.548C270.217 386.553 268.563 381.616 268.98 376.633",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M265.441 395.629C265.313 389.282 265.348 382.934 265.556 376.587",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M260.826 392.866C260.814 389.999 260.814 387.143 260.803 384.275C260.803 382.9 260.791 381.512 260.965 380.148C261.161 378.622 261.566 377.13 261.971 375.65",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M255.829 393.213C255.829 389.756 255.829 386.31 255.829 382.853C255.829 382.033 255.829 381.212 255.91 380.402C256.026 379.154 256.326 377.928 256.789 376.76",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M251.698 391.248C252.369 386.519 252.913 382.75 253.584 378.021",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M238.119 384.808C240.734 384.345 243.383 384.056 246.032 383.917",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M233.504 379.362C237.876 379.2 242.248 379.049 246.632 378.911",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M239.935 372.887C245.105 372.217 250.275 371.546 255.365 370.459",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M241.287 368.367C245.451 368.008 249.569 367.233 253.582 366.077",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M262.432 371.592C266.653 371.766 270.875 371.812 275.097 371.708",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M259.944 366.956C263.981 366.863 268.018 366.852 272.055 366.91",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M256.625 362.308C260.939 362.412 265.254 362.435 269.568 362.366",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M249.628 358.111C254.231 358.134 258.835 358.25 263.439 358.435",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M287.868 369.015C287.706 368.344 288.122 367.685 288.516 367.13C289.314 365.997 290.112 364.864 290.898 363.731C291.546 362.818 292.205 361.858 292.39 360.748",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M284.803 362.529C284.826 362.378 284.895 362.24 284.965 362.101C285.728 360.748 287.035 359.731 287.649 358.308",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M281.378 359.615C281.24 359.152 281.378 358.644 281.621 358.227C281.864 357.811 282.2 357.453 282.489 357.071C283.438 355.868 284.027 354.411 285.034 353.255",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M259.737 339.693C259.806 341.982 259.783 344.272 259.679 346.55",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M263.566 340.063C263.508 342.352 263.704 344.653 264.121 346.92",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M266.954 340.086C267.787 342.653 268.169 345.37 268.099 348.065",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M272.807 340.294C273.501 343.52 274.021 346.78 274.356 350.052",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M278.174 341.023C278.579 344.271 278.752 347.555 278.683 350.839",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M266.666 331.357C266.793 333.658 265.37 335.762 265.069 338.04",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M270.39 333.161C269.939 334.965 269.43 336.757 268.863 338.538",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M302.512 380.379C302.581 372.887 302.65 365.395 302.708 357.891",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M308.955 376.76C308.816 370.054 308.689 363.36 308.55 356.654",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M375.58 320.847C372.584 319.864 369.577 318.893 366.662 317.691C363.007 316.188 359.456 314.315 355.581 313.552",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M378.84 317.506C377.521 316.592 375.994 316.037 374.468 315.552C372.524 314.927 370.57 314.372 368.603 313.829C365.11 312.846 361.605 311.863 358.112 310.881",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M342.463 296.128C342.382 299.053 343.1 301.932 343.4 304.845C343.562 306.383 343.597 307.932 343.516 309.482",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M337.316 295.006C337.721 297.943 337.778 300.938 337.524 303.886C337.316 306.164 336.934 308.545 337.732 310.696",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M333.487 296.775C333.8 301.724 334.343 306.672 335.118 311.575",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M324.072 304.835C324.025 304.65 323.91 304.488 323.783 304.349C323.135 303.586 322.418 302.892 321.631 302.279C321.492 302.164 321.342 302.06 321.238 301.909C321.145 301.759 321.087 301.585 321.029 301.424C320.659 300.441 319.687 299.701 319.606 298.66",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M321.957 307.98C320.939 306.708 319.932 305.436 318.914 304.176C318.128 303.205 317.33 302.187 316.994 300.985",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M320.243 312.742C319.075 310.511 317.907 308.291 316.738 306.059C316.334 305.285 315.767 304.395 314.888 304.371",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M318.047 316.929C317.734 316.651 317.433 316.35 317.144 316.05C315.143 313.991 313.512 311.575 312.32 308.961",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M448.345 371.546C448.206 372.263 448.114 372.98 448.067 373.673",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M381.086 402.381C387.077 402.428 393.069 402.485 399.049 402.532",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M385.215 406.186C389.865 406.186 394.514 406.186 399.153 406.186",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M387.957 409.527C391.786 409.527 395.614 409.527 399.443 409.527",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M442.945 392.23C446.843 392.646 445.883 392.114 449.781 391.652C450.788 391.536 451.84 391.374 452.696 390.831",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M439.868 399.075C445.848 399.179 451.828 399.132 457.808 398.936",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M442.69 395.756C448.67 395.86 448.254 395.814 454.234 395.618",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M459.856 401.329C459.682 401.017 459.254 400.982 458.896 400.982C451.851 401.017 444.923 403.029 437.879 403.075",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M420.1 399.676C423.604 399.676 427.109 399.676 430.614 399.676",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M419.855 395.479C424.505 395.386 429.144 395.456 433.793 395.71",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M420.434 391.282C425.72 391.259 431.006 391.236 436.28 391.224",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M421.105 386.472C427.062 387.166 433.065 385.674 439.045 385.917",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M393.601 410.359C393.323 408.925 393.045 407.492 392.988 406.035C392.93 404.578 393.115 403.087 393.705 401.757",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M397.996 409.688C397.996 407.908 397.984 406.127 397.984 404.347C397.984 403.237 397.996 402.046 398.586 401.098",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M388.649 409.931C388.996 405.769 389.725 401.63 390.824 397.595",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M383.618 410.683C384.312 406.925 385.284 403.225 386.533 399.618",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M378.031 410.775C378.124 409.388 378.679 408.093 379.119 406.775C380.009 404.081 380.368 401.26 380.738 398.45",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M395.022 399.768C393.9 397.329 393.808 394.554 393.588 391.872C393.368 389.189 392.929 386.391 391.298 384.252",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M393.427 378.83C395.127 384.761 396.839 390.681 398.539 396.612",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M396.885 377.084C397.081 378.46 397.625 379.755 398.169 381.027C400.401 386.276 402.622 391.513 404.854 396.762",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M400.726 377.038C404.855 382.726 407.758 389.305 409.181 396.196",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M403.802 372.748C403.871 371.488 404.681 370.378 405.606 369.511C406.531 368.644 407.607 367.95 408.486 367.025C409.828 365.626 410.615 363.799 411.667 362.181C412.581 360.782 413.714 359.533 414.836 358.296",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M408.545 375.801C409.91 373.234 411.841 371.014 413.334 368.528C414.247 366.99 414.999 365.349 415.924 363.822C416.85 362.296 418.006 360.851 419.533 359.915",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M413.854 377.905C416.676 374.425 419.209 370.725 421.43 366.84C422.077 365.707 422.702 364.551 423.546 363.557",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M419.591 381.131C420.447 378.61 422.02 376.402 423.292 374.066C424.773 371.361 425.906 368.424 427.838 366.008",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M426.935 381.293C427.004 379.917 427.548 378.622 428.138 377.373C429.641 374.251 431.527 371.292 432.51 367.973",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M441.232 365.684C440.214 365.233 439.74 364.089 439.335 363.06C438.074 359.88 436.559 356.816 434.801 353.891",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M446.437 367.013C445.986 366.724 445.65 366.297 445.327 365.88C443.592 363.58 442.169 361.048 441.07 358.377C440.7 357.463 440.341 356.492 439.636 355.81",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M449.306 363.117C448.254 361.441 447.12 359.822 445.906 358.273C444.807 356.862 443.592 355.382 443.396 353.602",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M452.475 357.556C451.55 355.752 450.439 354.053 449.144 352.492C447.906 350.989 446.483 349.578 445.674 347.809",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M400.898 333.45C400.748 333.207 401.014 332.906 401.257 332.756C402.147 332.201 403.107 331.796 404.068 331.357C407.376 329.842 410.533 327.946 413.24 325.518C415.044 323.911 416.675 322.05 418.803 320.882",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M399.903 328.513C400.007 327.981 400.551 327.68 401.048 327.437C403.327 326.327 405.525 325.067 407.63 323.657C410.822 321.518 413.841 319.032 417.404 317.621",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M395.578 323.425C395.578 322.951 395.983 322.593 396.365 322.316C399.372 320.096 402.923 318.743 406.219 316.974C409.192 315.378 412.026 313.436 415.253 312.453",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M382.403 339.115C384.358 341.427 386.244 343.798 388.06 346.226",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M387.123 338.386C388.129 339.589 389.055 340.861 389.911 342.191C390.339 342.861 390.744 343.544 391.264 344.133C391.808 344.758 392.467 345.29 392.884 346.007",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M389.379 336.849C390.906 338.652 392.861 340.075 394.319 341.948C395.07 342.919 395.707 344.018 396.702 344.735",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M375 324.986C372.282 324.327 369.541 323.657 366.961 322.593C365.99 322.188 365.041 321.737 364.035 321.437C363.491 321.275 362.936 321.171 362.392 321.055C360.437 320.662 358.494 320.2 356.574 319.691",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M342.44 323.553C343.944 324.894 345.448 326.235 346.951 327.576C347.356 327.935 347.75 328.293 348.073 328.721C348.351 329.091 348.548 329.507 348.767 329.912C349.554 331.392 350.502 332.791 351.59 334.062",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M336.148 324.096C339.248 327.958 342.614 331.611 346.223 335.01",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M329 323.391C330.064 323.9 331.059 324.547 331.903 325.38C332.771 326.235 333.442 327.264 334.136 328.258C335.871 330.71 337.837 332.987 340.011 335.057",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M322.141 324.212C323.795 325.009 325.298 326.096 326.571 327.414C328.167 329.056 329.405 331.045 331.174 332.502C332.366 333.484 333.811 334.236 334.691 335.508",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M332.84 346.006C336.68 345.254 340.069 342.988 343.84 341.959C344.927 341.659 346.107 341.439 346.905 340.641",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M340.023 349.243C344.303 346.769 348.606 344.283 352.411 341.127",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M348.535 350.954C352.294 348.723 355.834 346.121 359.084 343.196",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M355.441 352.769C357.859 349.405 360.843 346.433 364.232 344.029",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M332.644 366.112C333.048 364.158 333.638 362.239 334.413 360.4C334.887 359.256 335.443 358.099 335.466 356.862",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M336.392 366.367C336.889 363.881 337.502 361.407 338.208 358.967",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M340.994 367.674C342.186 365.569 343.1 363.314 343.713 360.978",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M344.708 370.806C345.124 368.54 346.547 366.54 346.894 364.25C347.01 363.487 346.998 362.69 347.322 361.984",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M350.098 370.968C350.098 368.771 350.098 366.551 350.607 364.412C350.849 363.383 351.22 362.366 351.22 361.302",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M354.573 370.274C355.105 366.921 355.51 363.557 355.788 360.181",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M374.434 373.049C373.3 371.419 372.155 369.754 371.496 367.881C371.126 366.852 370.906 365.777 370.559 364.736C370.223 363.742 369.772 362.794 369.321 361.846C368.5 360.123 367.679 358.389 366.857 356.666",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M378.645 369.812C378.31 369.43 377.974 369.037 377.65 368.644C374.273 364.505 372.515 359.313 370.884 354.226",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M382.577 367.511C380.576 365.013 378.829 362.296 377.383 359.441C376.909 358.516 376.469 357.568 376.192 356.562C376.041 356.018 375.937 355.463 375.833 354.897C375.567 353.452 375.301 352.006 375.035 350.561",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M387.47 368.771C387.62 367.511 387.273 366.25 386.914 365.025C385.341 359.637 383.502 354.307 382.403 348.804",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M354.042 398.612C353.973 398.138 354.239 397.676 354.517 397.283C355.118 396.415 355.801 395.618 356.483 394.808C358.322 392.646 360.15 390.496 362.058 388.403C362.741 387.651 363.446 386.911 364.256 386.31C364.846 385.882 365.482 385.536 366.095 385.143C366.858 384.657 367.575 384.114 368.246 383.512",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M357.836 404.208C359.825 400.624 362.891 397.78 365.412 394.542C367.217 392.218 368.743 389.663 370.802 387.571",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M364.51 407.769C368.142 403.075 371.484 398.161 374.515 393.051",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M334.529 408.567C334.737 406.694 335.327 404.89 336.033 403.145C337.78 398.809 340.22 394.751 341.828 390.357C342.094 389.629 342.337 388.9 342.661 388.195C343.1 387.235 343.69 386.357 344.187 385.42C345.043 383.825 345.645 382.113 346.246 380.402",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M332.828 400.901C334.043 396.797 335.303 392.716 336.553 388.623C336.923 387.432 337.281 386.229 337.756 385.073C338.577 383.038 339.71 381.096 340.115 378.934",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M328.005 396.947C328.456 393.918 329.624 391.051 330.584 388.149C331.267 386.091 331.857 384.01 332.446 381.928C333.002 379.951 333.557 377.974 334.112 376.009",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M322.095 400.659C323.922 395.699 324.94 390.473 326.536 385.432C327.67 381.848 329.081 378.356 330.504 374.876",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M319.677 394.646C320.394 391.559 321.562 388.588 322.083 385.466C322.256 384.391 322.349 383.316 322.557 382.24C322.742 381.281 323.008 380.344 323.297 379.408C324.165 376.564 325.182 373.754 326.351 371.014",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M315.71 375.419C315.791 368.887 315.606 362.343 315.178 355.822",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M302.42 409.573C303.045 402.555 301.958 395.514 301.854 388.472",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M295.537 411.099C294.23 404.948 294.045 402.254 294.473 395.976",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M291.188 410.775C291.802 404.15 291.871 402.196 291.744 395.548",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M285.926 411.099C284.793 405.653 284.538 402.774 284.712 397.213",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M290.414 392.704C288.887 389.71 287.372 386.715 285.845 383.709C285.648 383.327 285.452 382.934 285.128 382.645C284.677 382.241 284.064 382.09 283.474 381.952",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M282.733 390.207C279.552 386.831 276.823 383.027 274.625 378.945",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M285.822 377.651C285.787 375.558 287.06 373.696 287.73 371.719C288.216 370.286 288.378 368.748 288.216 367.245",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M281.877 371.662C281.773 370.575 282.41 369.569 282.988 368.632C284.307 366.493 285.44 364.239 286.377 361.892",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M275.237 372.031C275.758 370.852 276.29 369.673 276.81 368.493C277.435 367.106 278.06 365.719 278.962 364.493C280.558 362.319 282.987 360.712 284.028 358.215",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M268.852 380.217C265.764 376.402 263.311 372.078 261.623 367.465C261.148 366.17 260.72 364.84 259.957 363.707",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M266.169 383.501C262.005 378.425 258.662 372.691 256.303 366.574",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M248.831 363.557C251.283 366.921 253.677 370.309 256.026 373.743C256.673 374.691 257.333 375.708 257.333 376.853",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M259.311 354.897C260.005 351.139 260.49 347.335 260.779 343.531",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M264.609 356.585C264.273 352.365 264.192 348.122 264.377 343.878",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M269.998 356.666C268.876 352.527 267.754 348.376 266.632 344.237",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M275.111 355.949C272.855 352.284 271.028 348.353 269.709 344.26",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M279.367 352.688C277.84 350.064 276.51 347.324 275.399 344.491",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M247.998 349.775L228.022 379.408L245.766 346.11L247.998 349.775Z",
    fill: "#0E0704",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVidfeo);
export default __webpack_public_path__ + "static/media/vidfeo.0a78b6abf543ee6ab148baf2557e9f16.svg";
export { ForwardRef as ReactComponent };